export const SupportTicketDemoData = [
    {
        id: 0,
        userId: 0,
        subject: 'string',
        department: 'string',
        subscriptionId: 0,
        lastMessage: 'string',
        isUrgent: true,
        havingAttachment: true,
        creator: 0,
        timeCreated: 0,
        timeUpdated: 0,
        messages: [
            {
                id: 0,
                supportTicketId: 0,
                message: 'string',
                attachmentUrl: 'string',
                messageFormat: 'string',
                status: 'string',
                creator: 0,
                timeCreated: 0
            }
        ],
        demo: true
    }
];

export const supportTicketInfoDemoData = {
    id: 3,
    userId: 0,
    subject: 'Payment Issue',
    department: 'technical',
    subscriptionId: 83,
    lastMessage: 'Hello There...',
    isUrgent: true,
    havingAttachment: false,
    creator: 9,
    timeCreated: 1703596113,
    timeUpdated: 1703848389,
    status: 'open',
    customerInfo: {
        id: 3,
        fullName: 'Noman Gazi',
        organization: 'BIKIRAN.COM',
        primaryEmail: 'numan.islam61@gmail.com',
        primaryPhone: '01726387662',
        photoUrl: 'https://storage.googleapis.com/miracle-bucket-23/profile_images/unnamed.jpg',
        role: 'admin',
        status: 'active',
        demo: true
    },
    messages: [
        {
            id: 5,
            supportTicketId: 3,
            message: 'Hello There...',
            attachmentUrl: '',
            messageFormat: 'text',
            status: 'active',
            creator: 0,
            timeCreated: 1703848367,
            creatorProfile: {
                id: 9,
                role: 'admin',
                agencyProfile: {
                    id: 0,
                    agencyName: '',
                    ownerUserId: 0,
                    status: '',
                    demo: true
                },
                firstName: 'Fahim',
                lastName: 'Hossain',
                organization: 'Bikiran',
                userName: 'fahim@bikiran.com',
                primaryEmail: 'fahim@bikiran.com',
                primaryPhone: '01897705073',
                gender: '',
                dateOfBirth: 1041184800,
                photoUrl:
                    'https://storage.googleapis.com/miracle-bucket-23/profile_images/profile.jpg',
                note: '',
                suspensionReason: '',
                tfaEnabled: false,
                status: '',
                demo: true
            },
            demo: true
        }
    ],
    demo: true
};

export default null;
